import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import { Event } from '../Tracking/Track';

class OyoOSmodule extends Component {


  render() {
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && this.props.viewMode && (
          <div style={gs('oyo_os_container')} ref={this.props.setOpmsRef}>
            <div style={gs('os_text_container')}>
              <div style={gs('oyo_os_head1')}>{gc('oyo_property_heading')}</div>
              <div style={gs('oyo_os_head2')}>
                {gc('oyo_property_sub_heading')}
              </div>
            </div>

            <div style={gs('main_body_style')}>
              <div
                style={
                  this.props.changeOyoOsModuleStyle
                    ? gs('left_body_style_flex_flow')
                    : gs('left_body_style')
                }
              >
                <div style={{ marginRight: '25px' }}>
                  <img src={gi('os_logo')} style={gs('os_logo_style')} />

                  {gc('oyo_os_1') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}>{gc('oyo_os_1')}</span>
                    </div>
                  )}
                  {gc('oyo_os_2') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('oyo_os_2')}</span>
                    </div>
                  )}

                  {gc('oyo_os_3') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('oyo_os_3')}</span>
                    </div>
                  )}

                  {gc('oyo_os_4') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('oyo_os_4')}</span>
                    </div>
                  )}
                  {gc('oyo_os_5') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('oyo_os_5')}</span>
                    </div>
                  )}
                </div>
                <div style={gs('os_content2')}>
                  <img src={gi('oyo_logo')} style={gs('oyo_logo_style')} />
                  <br />
                  {gc('co_oyo_1') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('co_oyo_1')}</span>
                    </div>
                  )}
                  {gc('co_oyo_2') !== null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('co_oyo_2')}</span>
                    </div>
                  )}
                  {gc('co_oyo_3') != null && (
                    <div style={gs('left_text_style')}>
                      <img
                        src={gi('os_bullet')}
                        style={gs('os_bullet_style')}
                      />
                      <span style={gs('oyo_os_body')}> {gc('co_oyo_3')}</span>
                    </div>
                  )}
                </div>
              </div>

              <div style={gs('right_body_style')}>
                <img src={gi('os_image')} style={gs('os_image_style')} />

                <div
                  onClick={() => {
                    Event('Partner Page', 'PMS Video clicked', '', '');
                    
                    this.props.handleOpenVideoModal('hdAzNHeSJbk', 'OYO OS');
                  }}
                  style={gs('play_container_style')}
                >
                  <img
                    src={gi('button_background')}
                    style={gs('button_background_style')}
                  />
                  <img
                    src={gi('play')}
                    className={'hover playOS'}
                    style={gs('play_style')}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OyoOSmodule);
